import { useEffect, useState } from 'react'
import CryptoAssistants from './CryptoAssistants'
import CardLayout from '../../../../components/layouts/CardLayout'
import ForexAssistants from './ForexAssistants'
import { Text, useWindowSize } from '../../../../modules/Dashboard'
import { TABLET_SIZE } from '../../../../core/constants/common'
import RCryptoAssistants from './responsive/RCryptoAssistants'
import RForexAssistants from './responsive/RForexAssistants'
import useAssistant from '../../hooks/useAssistant'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CategorizedAssistant from './CategorizedAssistant'
import MobileModal from '../../../../components/layouts/MobileModal'
import RCategorizedAssistant from './responsive/RCategorizedAssistants'
import { useGetUserPackage } from '../../../plans/services'
import { usePredictContext } from '../../context/PredictContextProvider'
import NewsCard from '../../../../components/main/dashboard/NewsCard'
import CurrentPlan from '../../../plans/components/CurrentUserPlan'

const AssistantsMain = () => {
    const { width } = useWindowSize()
    const { market } = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const { setIsLocked } = usePredictContext()
    const [activeTab, setActiveTab] = useState("crypto");
    const { data: userPackageData, loading: loadingUserPackage } = useGetUserPackage()
    const { loading: loadingAssistants, forexAssistants, cryptoAssistants, allAssistants } = useAssistant()

    const [suggestionModal, setSuggestionModal] = useState(true)
    const closeSuggestionModal = () => { setSuggestionModal(false) }

    const loading = loadingAssistants || loadingUserPackage

    const onTabClick = (tab) => {
        navigate(`/analyze/assistant/${tab}?step=assistant`)
    }

    useEffect(() => {
        setActiveTab(market)
    }, [location])

    useEffect(() => {
        if (!loading && userPackageData) {
            if (!userPackageData?.packageData) {
                setIsLocked(true)
            }
        }
    }, [userPackageData, loading])

    return (
        <div className='grid grid-cols-1 gap-10 w-full mx-auto'>
            {
                (market === 'crypto' || market === 'forex') &&
                <div className='mx-auto text-center mt-10'>
                    <Text tid={"analyzers-page-title"} className='text-3xl lg:text-4xl font-bold bg-gradient-to-r from-[#C27AFF] to-[#FC6432] bg-clip-text text-transparent' />
                </div>
            }
            {/* Current Active plan */}
            <CurrentPlan />
            {/* Tab Switcher */}
            <div className='col-span-1 md:hidden'>
                <div className="flex w-full justify-center items-center">
                    <button
                        onClick={() => onTabClick("crypto")}
                        className={`px-5 py-3 w-full ltr:rounded-l-xl rtl:rounded-r-xl transition
                                    ${activeTab === "crypto"
                                ? "bg-gradient-to-r from-[#A91ED2] to-[#F86313]"
                                : "bg-[#0F0524] text-white"
                            }
                                `}
                    >
                        <Text tid={"crypto-assistants"} className='text-sm xs:text-base' />
                    </button>

                    <button
                        onClick={() => onTabClick('forex')}
                        className={`px-5 py-3 w-full ltr:rounded-r-xl rtl:rounded-l-xl transition
                                        ${activeTab === "forex"
                                ? "bg-gradient-to-r from-[#A91ED2] to-[#F86313]"
                                : "bg-[#0F0524] text-white "
                            }
                                        `}
                    >
                        <Text tid={"forex-assistants"} className='text-sm xs:text-base' />
                    </button>
                </div>
            </div>
            {/* Crypto Assistants */}
            <div className={`${market && market !== 'crypto' ? "hidden" : ""}`}>
                <CardLayout title="crypto-assistants" className="!bg-transparent !border-none md:border-solid !border-purpleBorderDark md:bg-cardBgDark !p-0 md:p-8">
                    {width >= TABLET_SIZE ? <CryptoAssistants loading={loading} assistants={cryptoAssistants} /> : <RCryptoAssistants loading={loading} assistants={cryptoAssistants} />}
                </CardLayout>
            </div>
            {/* Forex Assistants */}
            <div className={`${market && market !== 'forex' ? "hidden" : ""}`}>
                <CardLayout title="forex-assistants" className="!bg-transparent !border-none md:border-solid !border-purpleBorderDark md:bg-cardBgDark !p-0 md:p-8">
                    {width >= TABLET_SIZE ? <ForexAssistants loading={loading} assistants={forexAssistants} /> : <RForexAssistants loading={loading} assistants={forexAssistants} />}
                </CardLayout>
            </div>
            {/* Suggestion list */}
            {width >= TABLET_SIZE &&
                <div className={`${market && market !== 'suggestions' ? "hidden" : ""}`}>
                    <CardLayout className="!bg-transparent !border-none md:border-solid !border-purpleBorderDark md:bg-cardBgDark !p-0 md:p-8">
                        <CategorizedAssistant allAssistants={allAssistants} />
                    </CardLayout>
                </div>
            }

            {/* New Card */}
            <div>
                <NewsCard />
            </div>

            {/* Suggestion float button */}
            {
                width <= TABLET_SIZE &&
                <button
                    onClick={() => { setSuggestionModal(true) }}
                    className='z-[999] fixed left-8 bottom-24 rounded-full bg-gradient-to-bl from-[#D08700] to-[#F54900] shadow-xl flex items-center justify-center w-[56px] h-[56px] animate-bounce'>
                    ⭐
                </button>
            }

            {/* Suggestion list mobile modal */}
            {
                width <= TABLET_SIZE &&
                <MobileModal isOpen={suggestionModal} onClose={closeSuggestionModal} noBg noPadding>
                    <RCategorizedAssistant allAssistants={allAssistants} />
                </MobileModal>
            }

        </div>
    )
}

export default AssistantsMain